export enum SearchScope {
  PARTS = 'parts',
  VENDORS = 'vendors',
}
